import React from 'react';

const STORAGE_KEY = 'tubeSizeScale';
export const MIN_SCALE = 0.25;
export const MAX_SCALE = 1.5;
const DEFAULT_DESKTOP_SCALE = 1;
const DEFAULT_MOBILE_SCALE = 0.6;
const MOBILE_BREAKPOINT = 480;

// Determine the initial scale: use saved preference if present,
// otherwise pick a sensible default based on screen width.
export function getInitialTubeScale() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved !== null) {
      const parsed = parseFloat(saved);
      if (!isNaN(parsed)) {
        return Math.min(MAX_SCALE, Math.max(MIN_SCALE, parsed));
      }
    }
  } catch (e) {
    // localStorage may be unavailable (e.g. private browsing) - ignore
  }

  if (typeof window !== 'undefined' && window.innerWidth <= MOBILE_BREAKPOINT) {
    return DEFAULT_MOBILE_SCALE;
  }
  return DEFAULT_DESKTOP_SCALE;
}

export function saveTubeScale(scale) {
  try {
    localStorage.setItem(STORAGE_KEY, String(scale));
  } catch (e) {
    // ignore storage errors
  }
}

const TubeSizeSlider = ({ scale, onScaleChange, theme }) => {
  const percent = Math.round(scale * 100);

  const handleChange = (e) => {
    const newScale = parseFloat(e.target.value);
    onScaleChange(newScale);
    saveTubeScale(newScale);
  };

  return (
    <div className="flex items-center gap-2">
      <label className={`text-sm font-medium ${theme.text} whitespace-nowrap`} htmlFor="tube-size-slider">
        Tube Size:
      </label>
      <input
        id="tube-size-slider"
        type="range"
        min={MIN_SCALE}
        max={MAX_SCALE}
        step={0.05}
        value={scale}
        onChange={handleChange}
        className="w-32 sm:w-40 accent-blue-600 cursor-pointer"
      />
      <span className={`text-sm ${theme.subtext} w-10 text-right`}>{percent}%</span>
    </div>
  );
};

export default TubeSizeSlider;
